module.exports = __webpack_public_path__ + "img/dm.664bf042.svg";